import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, pxToRem } from '@modernhealth/vital-components';
import { color, font } from 'src/shared/styles/variables';

const HeaderText = styled.h4(
    {
        color: color.ebonyClay,
        marginTop: 20,
        marginBottom: 0,
        textAlign: 'center',
    },
    font.black(font.size.extraLarge),
);

const DescriptionText = styled.p(
    {
        color: color.blueBayoux,
        marginTop: 10,
        marginBottom: 15,
        textAlign: 'center',
        maxWidth: 350,
    },
    font.book(font.size.large),
);

const SubmitButton = styled(Button)({
    marginTop: pxToRem(50),
});

const NotNowButton = styled(Button)({
    marginTop: pxToRem(10),
});

interface Props {
    onSubmitClick: () => void;
    onNotNowClick: () => void;
    loading: boolean;
}

export const RateSessionBeforeYouLeaveStep: React.FC<Props> = ({
    onSubmitClick,
    onNotNowClick,
    loading,
}) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <HeaderText>{t('videoSessions:rate_session.before_leave.title')}</HeaderText>
            <DescriptionText>
                {t('videoSessions:rate_session.before_leave.description')}
            </DescriptionText>

            <SubmitButton onClick={onSubmitClick} busy={loading} fluid>
                {t('common.submit')}
            </SubmitButton>
            <NotNowButton onClick={onNotNowClick} variant="secondary" fluid>
                {t('common.not_now')}
            </NotNowButton>
        </React.Fragment>
    );
};
